import { z } from "zod";
import { AccountUserSchema } from "./AccountUser";
import { BaseChangelogSchema } from "./Changelog";

export const AccountCompanyChangelogSchema = BaseChangelogSchema.extend({
  accountUser: AccountUserSchema.nullable(),
});
export const PartialAccountCompanyChangelogSchema =
  AccountCompanyChangelogSchema.deepPartial();

export type PartialAccountCompanyChangelog = z.infer<
  typeof PartialAccountCompanyChangelogSchema
>;

export type AccountCompanyChangelog = z.infer<
  typeof AccountCompanyChangelogSchema
>;
